export const CourseHeader = () => {
    return (
        <div className="bg-gray-50 border rounded-2xl px-6 py-5">
            <div className="max-w-3xl">
                <h1 className="text-2xl font-semibold text-gray-900">
                    Course communication
                </h1>

                <p className="text-sm text-gray-600 mt-2">
                    This page contains all communication related to the course.
                    You can join the group discussion and access lesson-specific conversations.
                </p>

                {/* Meta line */}
                <div className="flex items-center gap-6 mt-4 text-sm text-gray-500">
                    <span className="flex items-center gap-1">
                        💬 Group chat
                    </span>
                    <span className="flex items-center gap-1">
                        📖 Lessons
                    </span>
                    <span className="flex items-center gap-1">
                        🔒 Private discussions
                    </span>
                </div>
            </div>
        </div>
    )
}
